
// 语言下拉选择种类
let langMenus = {
    'zh-cn': '中文(简体)',
    'pt-pt': 'Português',
    'en-us': 'English',
}

// 浏览器默认语言对应的展示文字
let langTypes = {
    'zh-cn': '中文(简体)',
    'pt-pt': 'Português',
    'en-us': 'English',
    'pt': 'Português',
    'en': 'English',
}

// 浏览器默认语言与支持语言的对应关系，用于传给iframe url
let langRelations = {
    'default': 'pt',
    'zh-cn': 'zh',
    'zh': 'zh',
    'pt-pt': 'pt',
    'en-us': 'en',
    'pt': 'pt',
    'en': 'en',
    'fr':'fr'
}

export {langMenus, langTypes, langRelations}



// WEBPACK FOOTER //
// ./src/model/languages.js